// Meta Pixel / Facebook Ads Tracking Utility
// Replace PIXEL_ID in mock.js with your actual Facebook/Meta Pixel ID

import { PIXEL_ID } from '../data/mock';

export const initMetaPixel = () => {
  if (typeof window === 'undefined' || window.fbq) return;

  (function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  window.fbq('init', PIXEL_ID);
  window.fbq('track', 'PageView');
};

// Track when a user clicks the purchase/CTA button
export const trackPurchaseClick = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'Manual Cejas Radiantes',
      content_type: 'product',
      value: 14.99,
      currency: 'USD',
    });
  }
};

// Track page view (called automatically on init)
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};

// Track lead generation
export const trackLead = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead');
  }
};
